import { ModuleWithProviders, NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { HttpClientModule } from "@angular/common/http";

import { CART_ITEM_CLASS } from "./services/item-class.token";
import { CART_SERVICE_CONFIGURATION } from "./services/service-configuration.token";
import { CART_SERVICE_TYPE } from "./services/service-type.token";
import {
  serviceFactory,
  setItemClass,
  setServiceConfiguration,
  setupService,
} from "./service.factory";
import { CartService } from "./cart.service";
import { CartModuleOptions } from "./interfaces/cart-module-options";
import { CartViewComponent } from "./components/cart-view.component";

/**
 * The main exported library module. It includes `forRoot` and `forChild` static methods to support angular feature modules and singleton
 * services.
 *
 * @note {danger} Only the `forRoot` method will configure providers for you. If you use the module without it you must configure the
 * library providers yourself.
 */
@NgModule({
  imports: [CommonModule, HttpClientModule],
  declarations: [CartViewComponent],
  exports: [CartViewComponent],
})
export class ShoppingCartModule {
  static forRoot(options: CartModuleOptions = {}): ModuleWithProviders<any> {
    return {
      ngModule: ShoppingCartModule,
      providers: [
        setItemClass(options.itemType),
        setupService(options.serviceType),
        setServiceConfiguration(options.serviceType, options.serviceOptions),
        {
          provide: CartService,
          useFactory: serviceFactory,
          deps: [
            CART_SERVICE_TYPE,
            CART_ITEM_CLASS,
            CART_SERVICE_CONFIGURATION,
          ],
        },
      ],
    };
  }

  static forChild(): ModuleWithProviders<any> {
    return {
      ngModule: ShoppingCartModule,
    };
  }
}
